import { GzIconLabelWebComponent } from './component/GzIconLabelWebComponent';
import { WEB_COMPONENT_GZ_ICON_LABEL } from '../../webcomponents.constants';

export { GzIconLabelWebComponent };

window.customElements.define(WEB_COMPONENT_GZ_ICON_LABEL, GzIconLabelWebComponent);
